

<template>

  <div>
    <div class="box" v-if="languageSelect==='zh'">
      <div class="ViewTitle">职位沟通</div>
      <div class="messageList">
        <div  style="display: flex">
          <div class="middle" v-if="messageList.length">
            <li v-for="(lists,index) in messageList" :key="index">
              <div class="listTotle" @click="personal(lists)">
                <div class="detail">
                  <div >
                    <div>
                      <span class="positionName"> {{lists.positionName}}</span>
                      <span class="salaryName"> {{lists.positionSalary}}</span>
                    </div>
                    <div class="jobStyle">
                      <span class="jobStyle1">{{lists.positionTime}}</span>
                      <span class="jobStyle2">{{lists.positionEducation}}</span>
                    </div>
                  </div>
                  <div class="comLogo">
                    <img :src="baseURL + lists.companyAvatar" alt="" />
                  </div>
                  <div class="companyName">
                    <div class="name1">{{lists.companyName}} </div>
                    <div class="name2">{{lists.companyScale}} </div>
                  </div>
                  <div class="comButton">
                    <el-button class="companyBut"  @click="communicate()">已沟通</el-button>
                  </div>



                </div>
                <div class="bottom">
                  <div class="address"> </div>
                  <div class="positionAddress">{{lists.positionAddress}}</div>

                </div>

              </div>

            </li>
            <div v-if="messageList.length !== 0" class="pagination-container">
              <el-pagination
                  v-model="page"
                  :current-page="page"
                  :page-size='size'
                  :page-sizes="[5, 8, 10, 15]"
                  :total="total"
                  background
                  layout="sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
              >
              </el-pagination>
            </div>
          </div>
          <div class="noData" style="width: 1280px" v-else>
            <img src="@/assets/none.png"  alt="" />
            暂无数据
          </div>

          <div class="jianli" v-if="userId">
            <PersonalLittle></PersonalLittle>
          </div>
        </div>

      </div>
    </div>


  </div>

</template>


<script>

import {shareUrl} from "@/utils/vxshare";
import PersonalLittle from "@/components/PersonalLittle.vue";
export default {

  name: "",

  props: [],

  components: {PersonalLittle},

  data() {

    return {
      loginIn:false,
      dialogVisible: false,
      dialogVisibleInfo: false,
      registerIn:false,
      forgetIn:false,
      baseURL: this.$utils.baseURL,
      isMobile: false,
      messageList: [],
      page: 1,
      size:8,
      total:"",
      userId:localStorage.getItem("userId"),
      languageSelect:''
    };

  },

  methods: {
    hideDialog() {
      this.dialogVisible = false;
    },
    hideDialogInfo() {
      this.dialogVisibleInfo = false;
    },
    hideLoginIn(){
      this.loginIn=false

    },
    logsuccess(){
      this.loginIn=false
      this.userId= this.$store.state.userId
      window.location.reload();

    },
    showRegister(){
      this.loginIn=false
      this.registerIn=true
    },
    forget(){
      this.loginIn=false
      this.forgetIn=true
    },
    hideregisterIn(){
      this.registerIn=false
    },
    hidereforgetIn(){
      this.forgetIn=false
    },
    login(){
      this.loginIn=true
      this.registerIn=false
    },

    showLoginIn(){
      this.loginIn=true
    },
    // 详情
    personal(list){
      console.log(list)
      this.$router.push({
        path: "/positionDetail",
        query: {
          positionId:list.positionId,
        },
      });
      // window.location.reload();

    },
    handleSizeChange(val) {
      this.size = val;
      // console.log(`每页 ${val} 条`+this.size)
      // console.log('gengxin')

      this.getartical();
    },
    handleCurrentChange(val) {
      this.page = val;
      // this.handleScroll();
      // console.log(`当前页: ${val}`+this.page)
      this.$forceUpdate(); //强制重新渲染分页器组件
      this.getartical();
    },
    getData(){
      this.$axios
          .get("/system/deliveryStatus/deliveryList", {
            params: {
             userId:this.userId,
              pageNum:this.page,
              pageSize:this.size
            },
            headers: {
              Authorization: this.token,
            },
          })
          .then((res) => {
            console.log(res.data)
            this.messageList = res.data.rows; // 将响应中的数据直接赋值给 articles 对象数组
            this.total=res.data.total

          })
          .catch((error) => {
            console.log(error);
          });
    }
  },

  created() {
    if (localStorage.getItem('language')) {
      this.languageSelect = localStorage.getItem('language')
    } else {
      this.languageSelect = 'zh'
    }
    let url = window.location.host
    // let url = 'https://oilgasinfoai.com/?language=zh'
    setTimeout(() => {
      //encodeURIComponent 将你的URL进行转译一下，因为微信分享出去后会带有多余用不到的参数
      let shareData = {
        url:url,
        title:'油气人才',
        text:'洞悉油气行业变化，体验AI大模型，就来油气人才！',
      }
      shareUrl(shareData);
    }, 1000);
    this.getData()
  },
  mounted() {
      window.scrollTo(0, 0); // 在页面加载时滚动到页面顶部
      // Check if the device width is less than 768px (example for mobile)
      this.isMobile = window.matchMedia("(max-width: 767px)").matches;

  }

}

</script>


<style type="text/scss" lang="scss" scoped>
.jianli {
  margin: 20px 0 0 20px;
  width: 260px;
  height: 267px;
  background: #FFFFFF;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
}

.recommend2 {
  left: 50vw;
  position: absolute;
  width: 280px;
  height: 340px;
  top:20px;
  box-shadow: 0px 0px 1.4vh 0px rgba(0,0,0,0.05);
  border-radius: 4px 4px 4px 4px;
  .item {
    width: 100%;
    cursor: pointer;
    padding: 2.3vh 1.0vw;
    font-size: 18px;
    color: #333333;
  }
  .item:hover {
    background: var(--main-color);
    color: #fff;
  }
  .item:not(:last-child) {
    border-bottom: 1px dotted #cecece;
  }
}
.middle{
  overflow:hidden;
  margin:0;
  width: 950px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  list-style: none;


  .pagination-container {
    position: sticky;
    margin-top: 20px;
    padding: 25px;
    bottom: 15px;
    width: 99%;
    text-align: center;
    ::v-deep .el-pager li {
      border-radius: 8px;
      background-color: white;
      border: rgba(100, 98, 98, 0.2) 1px solid;
    }
    ::v-deep .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
      border-radius: 8px;
      background-color: white;
      border: rgba(100, 98, 98, 0.2) 1px solid;

    }
    ::v-deep .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
      border-radius: 8px;
      background-color: white;
      border: rgba(100, 98, 98, 0.2) 1px solid;
    }
  ;
  }


  .listTotle{
    margin-top: 20px;
    width: 100%;
    height: 142px;
    background: #FFFFFF;
    box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    .detail{
      padding: 20px;
      display: flex;
      cursor: pointer;
      position: relative;
      .positionName{
        width: 64px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 16px;
      }
      .salaryName{
        margin-left: 12px;
        width: 41px;
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #BF0022;
        line-height: 16px;
      }
      .jobStyle{
        display: flex;
        margin-top: 16px;
        width: 18vw;
        .jobStyle1{
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          background-color: #F5F5F5;
          padding:3px 10px;
        }
        .jobStyle1:hover{
          color:#BF0022;
          transform: scale(1.2);
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }
        .jobStyle2
        {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          background-color: #F5F5F5;
          padding:3px 10px;
          margin-left:0.42vw
        }
        .jobStyle2:hover{
          color:#BF0022;
          transform: scale(1.2);
          transition: transform 0.3s ease-in-out; /* 添加过渡效果 */
        }
      }
      .comLogo{
        position: absolute;
        width: 54px;
        height: 54px;
        border-radius: 2px 2px 2px 2px;
        opacity: 1;
        border: 1px solid rgba(0,0,0,0.02);
        margin-left: 25.8vw;
      }
      .companyName{
        position: absolute;
        border-radius: 2px 2px 2px 2px;
        opacity: 1;
        margin-left:29.2vw;
        .name1{
          width: 140px;
          margin-top: 6px;
          height: 16px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 16px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .name2{
          height: 16px;
          margin-top: 10px;
          font-size: 13px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 16px;
        }
      }
      .comButton{
        position: absolute;
        right: 20px;
        top:31px;
        .companyBut{
          width: 92px;
          height: 32px;
          border: none;
          font-size: 14px;
          font-weight: 400;
          color: #BF0022;
          background: #FAEBEE;
          border-radius: 15px 15px 15px 15px;
          opacity: 1;
        }
        .companyBut:hover {
          /* 此处是鼠标悬浮时的样式 */
          color: #FFFFFF;
          background: #BF0022;
          /* 你可以添加其他的样式以突出悬浮状态 */
        }


        ::v-deep .el-button{
          padding: 5px 10px;
        }
      }
    }
    .bottom{
      padding:18px  20px;
      width: 100%;
      height: 48px;
      background: linear-gradient(99deg, #FAEBEE 0%, #FCFBFA 62%);
      opacity: 1;
      display: flex;
      .address{
        width: 10px;
        height: 12px;
        background-image: url("../../assets/addressbg.png");
        background-size:contain;
        background-position:center;
        background-repeat:no-repeat
      }
      .positionAddress{
        height: 16px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 16px;
        margin-left: 5px;
        margin-top: -2px;
      }
    }

  }
}
.jianli {
  margin: 20px 0 0 0;
  width: 260px;
  height: 267px;
  background: #FFFFFF;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
}
.box {

  width: 100%;
  background: #fff;
  //background: #fff;
  .ViewTitle {
    height: 67px;
    line-height: 67px;
    border-bottom: 1px solid #ebebeb;
    font-size: 20px;
    color: #333333;
    font-weight: 400;
    padding: 0 30px;
  }

  .messageList {
    width: 98%;
    padding-bottom: 48px;
    .list {
      padding: 0 30px;
      .item {
        display: flex;
        align-items: center;
        padding: 17px 22px;
        border: 1px solid #ebebeb;
        margin-top: 16px;
        .icon {
          width: 48px;
          height: 48px;
          margin-right: 12px;
        }
        .text {
          flex:1;
          .title {
            font-size: 14px;
            color: #000;
            font-weight: 500;
            cursor: pointer;
            max-width: 100%;
            width: fit-content;
            .step {
              .el-badge__content.is-dot {
                background-color: var(--main-color) !important;
              }
            }
          }
          .flex {
            display: flex;
            font-size: 12px;
            align-items: center;
            margin-top: 6px;
            .time {
              color: #999999;
              margin-right: 11px;
            }
            span {
              color: var(--main-color);
              font-weight: 500;
              cursor: pointer;
            }
          }
        }
      }

      .el-pagination {
        text-align: center;
        margin-top: 30px;
      }
    }
  }
}
</style>
